import React, { useEffect, useState,  } from "react";
import { Notification, toaster } from "rsuite";
import { Radio } from "rsuite";
import "./tariffPanel.css";
import SortableTariffs from "../../../components/sortableTariffs/sortableTariffs";
import FilterModal from "../../../components/filterModal/FilterModal";
import { useInvoiceContext } from "../createInvoiceContext";
import { Loader } from 'rsuite';
import { getTariffs } from "../../../api/logistic";
import { useLanguage } from "../../../context/localeContext";
import { getCurrencySymbol } from "../../../utils/currencyHelper";
import { useTranslation } from "react-i18next";
import { voiceTariffKZToRU } from "../../../utils/voiceTariffKZToRU";

const LabelWithSubLabel = ({ label, subLabel }) => {
  return (
      <div className={`labelWithSubLabel`}>
          <div className="paragraph-14R" style={{color: "var(--Gray-900)"}}>{label}</div>
          <div className="paragraph-12R">{subLabel}</div>
      </div>
  )
}

const LabelWithValueAndKey = ({ label, subLabel, value }) => {
  return (
      <div className={`labelWithValueAndKey`}>
          <LabelWithSubLabel label={label} subLabel={subLabel} />
          <div className="paragraph-12M labelValue">{value}</div>
      </div>
  )
}


const InvoiceTariff = () => {
  const { t } = useTranslation('basic');
  const { invoiceData, setInvoiceData } = useInvoiceContext();
  const { language } = useLanguage();

  const [tariffs, setTariffs] = useState([]); // Исходный список тарифов
  const [displayedTariffs, setDisplayedTariffs] = useState([]); // Отображаемые тарифы
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedTariff, setSelectedTariff] = useState(null);
  const [isSortPanelOpen, setSortPanelOpen] = useState(false);
  const [currentSort, setCurrentSort] = useState("price-asc");
  const [isFilterOpen, setFilterOpen] = useState(false);
  const [filters, setFilters] = useState({
    fromWarehouse: false,
    fromDoor: false,
    toWarehouse: false,
    toDoor: false,
  });

  const currencySymbol = getCurrencySymbol(invoiceData?.user_info);

  // Обработчик показа ошибки
  const showError = () => {
    toaster.push(
      <Notification type="error" header={t("error")} closable>
        {t("tariff_not_selected")}
      </Notification>,
      { placement: "topStart", duration: 3000 }
    );
  };

  // Обработчик перехода к следующему шагу
  const handleNextStep = () => {
    if (!invoiceData.tariff) {
      showError();
      return;
    }
    // Логика перехода к следующему шагу
  };

  // Фильтрация тарифов
  const applyFilters = (tariffs, filters) => {
    if (!Object.values(filters).some(v => v)) return tariffs;
    return tariffs.filter(({ delivery_mode }) => {
      const activeFilters = Object.values(filters).filter(Boolean).length;
      let matches = 0;
      if (filters.fromDoor && (delivery_mode === 1 || delivery_mode === 2)) matches++;
      if (filters.fromWarehouse && (delivery_mode === 3 || delivery_mode === 4)) matches++;
      if (filters.toDoor && (delivery_mode === 1 || delivery_mode === 3)) matches++;
      if (filters.toWarehouse && (delivery_mode === 2 || delivery_mode === 4)) matches++;
      return matches === activeFilters;
    });
  };

  // Сортировка тарифов
  const applySorting = (tariffs, criteria) => {
    return [...tariffs].sort((a, b) => {
      if (criteria === "price-asc") return a.delivery_sum - b.delivery_sum;
      if (criteria === "price-desc") return b.delivery_sum - a.delivery_sum;
      if (criteria === "time-asc") return a.period_min - b.period_min;
      if (criteria === "time-desc") return b.period_min - a.period_min;
      return 0;
    });
  };

  // Применение фильтров и сортировки
  useEffect(() => {
    let result = applyFilters(tariffs, filters);
    result = applySorting(result, currentSort);
    setDisplayedTariffs(result);
    console.log("Фильтры изменены в tariffPanel:", filters);
  }, [tariffs, filters, currentSort]);


  // Загрузка тарифов
  useEffect(() => {
    const loadTariffs = async () => {
      try {
        const data = await getTariffs({
          contract_number: invoiceData.contract_number,
          lang: language,
          city_from: invoiceData.cityFrom,
          city_to: invoiceData.cityTo,
          packages: invoiceData.places,
          contract_vat_percent: invoiceData.contract_vat_percent
        });
        setTariffs(data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    loadTariffs();
  }, []);

  useEffect(() => {
    if (!invoiceData.tariff || !tariffs) return;


    setInvoiceData(oldData => ({
      ...oldData,
      delivery_sum: tariffs.find(tariff => tariff.tariff_code === invoiceData.tariff)?.delivery_sum,
      selected_mode: tariffs.find(tariff => tariff.tariff_code === invoiceData.tariff)?.delivery_mode,
      period_min: tariffs.find(tariff => tariff.tariff_code === invoiceData.tariff)?.period_min,
      period_max: tariffs.find(tariff => tariff.tariff_code === invoiceData.tariff)?.period_max,
      tariff_name: tariffs.find(tariff => tariff.tariff_code === invoiceData.tariff)?.tariff_name,
    }))
  }, [invoiceData.tariff, tariffs]);

  useEffect(() => {
    if (!invoiceData.v_tariff_type) return;

    // When language is KZ, voice returns Kazakh terms; API tariff names are in RU → normalize KZ to RU for matching
    const typeFirstWord = language === "kz"
      ? voiceTariffKZToRU(invoiceData).typeFirstWord
      : invoiceData.v_tariff_type.split(" ")[0].toLowerCase();
    const fromTo = language === "kz"
      ? voiceTariffKZToRU(invoiceData).fromTo
      : (invoiceData.v_tariff_from + "-" + invoiceData.v_tariff_to).toLowerCase();

    let filtered = tariffs.filter(tariff => tariff.tariff_name.split(" ")[0].toLowerCase() === typeFirstWord);

    filtered.forEach((t) => {
      let type = t.tariff_name.split(" ").slice(-1)[0].toLowerCase();
      if (type === fromTo) {
        setInvoiceData(oldData => ({
          ...oldData,
          tariff: t.tariff_code,
          v_tariff_type: null
        }));
      }
    });
  }, [tariffs, language, invoiceData.v_tariff_type, invoiceData.v_tariff_from, invoiceData.v_tariff_to]);

  // Обработчик выбора тарифа
  const handleApplyFilters = (tariffs, appliedFilters) => {
    
    setFilterOpen(false);
    const filteredTariffs = applyFilters(tariffs, appliedFilters);
    const sortedTariffs = applySorting(filteredTariffs, currentSort);
    setDisplayedTariffs(sortedTariffs);
    console.log("Полученные фильтры до обновления:", appliedFilters);

    setFilters((prev) => {
        console.log("Старые фильтры:", prev);
        console.log("Новые фильтры:", appliedFilters);
        return { ...appliedFilters };
    });
};

  const getSortText = () => {
    switch (currentSort) {
      case "price-asc":
        return (
          <>
            <span>{t("price")}</span>
            <svg
              width="11"
              height="12"
              viewBox="0 0 11 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                id="Icon"
                d="M9.875 6.83333L5.5 11M5.5 11L1.125 6.83333M5.5 11L5.5 1"
                stroke="#17C653"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </>
        );
      case "price-desc":
        return (
          <>
            <span>{t("price")}</span>
            <svg
              width="11"
              height="12"
              viewBox="0 0 11 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                id="Icon"
                d="M9.875 5.16667L5.5 1M5.5 1L1.125 5.16667M5.5 1L5.5 11"
                stroke="#17C653"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </>
        );
      case "time-asc":
        return (
          <>
            <span>{t("period")}</span>
            <svg
              width="11"
              height="12"
              viewBox="0 0 11 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                id="Icon"
                d="M9.875 6.83333L5.5 11M5.5 11L1.125 6.83333M5.5 11L5.5 1"
                stroke="#17C653"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </>
        );
      case "time-desc":
        return (
          <>
            <span>{t("period")}</span>
            <svg
              width="11"
              height="12"
              viewBox="0 0 11 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                id="Icon"
                d="M9.875 5.16667L5.5 1M5.5 1L1.125 5.16667M5.5 1L5.5 11"
                stroke="#17C653"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </>
        );
      default:
        return <span>{t("price")}</span>;
    }
  };

  if (loading) {
    return (
      <div className="loader-container">
        <Loader size="lg"/>
      </div>
    );
  }

  if (error) {
    return <div>{t("error_loading_tariffs")}: {error}</div>;
  }

  return (
    <div className="tariff-panel">
      <div className="tariff-header">
        <div className="header-left">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M10 10V9C9.44771 9 9 9.44771 9 10H10ZM10.0708 10H11.0708C11.0708 9.44771 10.6231 9 10.0708 9V10ZM10.0708 10.0641V11.0641C10.6231 11.0641 11.0708 10.6163 11.0708 10.0641H10.0708ZM10 10.0641H9C9 10.6163 9.44771 11.0641 10 11.0641V10.0641ZM17 10C17 13.866 13.866 17 10 17V19C14.9706 19 19 14.9706 19 10H17ZM10 17C6.13401 17 3 13.866 3 10H1C1 14.9706 5.02944 19 10 19V17ZM3 10C3 6.13401 6.13401 3 10 3V1C5.02944 1 1 5.02944 1 10H3ZM10 3C13.866 3 17 6.13401 17 10H19C19 5.02944 14.9706 1 10 1V3ZM13 10C13 11.6569 11.6569 13 10 13V15C12.7614 15 15 12.7614 15 10H13ZM10 13C8.34314 13 7 11.6569 7 10H5C5 12.7614 7.23858 15 10 15V13ZM7 10C7 8.34314 8.34314 7 10 7V5C7.23858 5 5 7.23858 5 10H7ZM10 7C11.6569 7 13 8.34314 13 10H15C15 7.23858 12.7614 5 10 5V7ZM10 11H10.0708V9H10V11ZM9.07084 10V10.0641H11.0708V10H9.07084ZM10.0708 9.06406H10V11.0641H10.0708V9.06406ZM11 10.0641V10H9V10.0641H11Z" fill="url(#paint0_linear_1_2501)"/>
          <defs>
            <linearGradient id="paint0_linear_1_2501" x1="2" y1="10" x2="18" y2="10" gradientUnits="userSpaceOnUse">
              <stop stop-color="#55E5FF"/>
              <stop offset="1" stop-color="#5DFF66"/>
            </linearGradient>
          </defs>
        </svg>
          <h2 className="paragraph-16M">{t("tariff_selection")}</h2>
        </div>
        <div className="header-bottom">
        <button className="sort-button paragraph-12R" onClick={() => setSortPanelOpen(true)}>
          {t("sort_by")} <span className="sort-text paragraph-12M">{getSortText()}</span>
        </button>
          <button className="filter-button paragraph-12R" onClick={() => setFilterOpen(true)}>
            {t("filter")}
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="filter">
            <path id="Icon" d="M6.6002 12H17.4002M4.2002 7.19995H19.8002M10.2002 16.8H13.8002" stroke="#17C653" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            </svg>
          </button>
        </div>
      </div>

      <div className="tariff-list">
        {displayedTariffs.length > 0 ? (
          displayedTariffs.map((tariff) => (
            <div
              key={tariff.tariff_code}
              className={`tariff-item ${invoiceData.tariff === tariff.tariff_code ? "selected" : ""}`}
              onClick={() => {

                setInvoiceData(oldData => ({
                  ...oldData,
                  tariff: tariff.tariff_code,
                  delivery_sum: tariff.delivery_sum * (invoiceData?.user_info?.contract_vat || 1),
                  selected_mode: tariff.delivery_mode,
                  period_min: tariff.period_min,
                  period_max: tariff.period_max,
                  tariff_name: tariff.tariff_name
                }))
              }}
            >
              <Radio
                checked={invoiceData.tariff === tariff.tariff_code}
                onChange={() => {
                  setInvoiceData(oldData => ({
                    ...oldData,
                    tariff: tariff.tariff_code,
                    delivery_sum: tariff.delivery_sum * (invoiceData?.user_info?.contract_vat || 1),
                    selected_mode: tariff.delivery_mode,
                    period_min: tariff.period_min,
                    period_max: tariff.period_max,
                    tariff_name: tariff.tariff_name
                  }))
                }}
                color="green"
                className="tariff-radio"
              />
              <LabelWithValueAndKey
                label={tariff.tariff_name}
                subLabel={`${t("from")} ${tariff.period_min} ${t("to")} ${tariff.period_max} ${t("working_days")}`}
                value={Math.ceil(tariff.delivery_sum * (invoiceData?.user_info?.contract_vat || 1)) + " " + currencySymbol}
              />
            </div>
          ))
        ) : (
          <div>{t("no_tariffs_available")}</div>
        )}
      </div>

      <SortableTariffs
        isOpen={isSortPanelOpen}
        onClose={() => setSortPanelOpen(false)}
        onSortChange={setCurrentSort}
        currentSort={currentSort}
      />

      <FilterModal
        isOpen={isFilterOpen}
        onClose={() => setFilterOpen(false)}
        onApply={(appliedFilters) => handleApplyFilters(tariffs, appliedFilters)}
        onReset={() => {
          setFilters({
            fromWarehouse: false,
            fromDoor: false,
            toWarehouse: false,
            toDoor: false,
          });
        }} // Передаем сброс
        tariffs={tariffs} // Передаем тарифы
        setDisplayedTariffs={setDisplayedTariffs} // Передаем функцию обновления
        setFilterOpen={setFilterOpen} // Передаем управление открытием
      />
    </div>
  );
};

export default InvoiceTariff;
